var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 0.872131L15.4264 7.79572L23.0752 8.90554L17.5371 14.2966L18.8483 21.9137L12.0015 18.3184L5.15995 21.9136L6.46419 14.2969L0.923828 8.90549L8.57791 7.7957L12.0013 0.872131ZM12.0015 3.12784L9.24142 8.70996L3.0755 9.60397L7.53864 13.9471L6.48738 20.0864L12.0013 17.1888L17.519 20.0862L16.4622 13.9473L20.9241 9.60391L14.763 8.70994L12.0015 3.12784Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetences);
export default __webpack_public_path__ + "static/media/competences.ca9aed2564fef25756cca12722470ace.svg";
export { ForwardRef as ReactComponent };